export const articles = [
  {
    id: 1,
    title: '2026年最值得关注的前端技术趋势：从React到WebAssembly',
    excerpt: '前端技术日新月异，2026年有哪些技术值得开发者重点关注？本文从React 19新特性、WebAssembly应用场景、以及AI辅助开发三个维度进行全面分析。',
    contentHtml: `<article>
  <p>前端技术的发展速度令人眼花缭乱，2026年更是带来了诸多令人兴奋的新变化。本文将为您梳理当前最值得关注的前端技术趋势，帮助开发者在技术选型和职业规划上做出明智决策。</p>

  <h2>React 19 带来的范式转变</h2>
  <p>React 19的发布标志着React生态进入了一个全新的阶段。Server Components的成熟让前后端渲染边界变得模糊，开发者可以用更直观的方式编写全栈应用。新的并发特性让用户体验更加流畅，而改进的Hooks API让状态管理变得更加简单。</p>
  <p>在实际项目中，我们已经看到大量团队开始迁移到React 19。特别是在大型企业应用中，Server Components显著减少了客户端JavaScript的体积，首屏加载速度平均提升了40%以上。</p>

  <h2>WebAssembly不再只是"未来"</h2>
  <p>如果说前几年WebAssembly还是一个"实验性"技术，那么2026年它已经真正走向了生产环境。从图像处理到视频编码，从游戏引擎到科学计算，WebAssembly正在越来越多的场景中发挥其性能优势。</p>
  <p>特别是在浏览器端AI推理方面，WebAssembly配合WebGPU让本地运行大模型成为可能，这对于注重隐私保护的应用场景来说意义重大。</p>

  <h2>AI辅助开发工具全面普及</h2>
  <p>GitHub Copilot、Cursor、Windsurf等AI编程助手已经成为开发者的标配工具。根据最新的开发者调查，超过75%的开发者日常使用AI辅助工具进行编码。这不仅大幅提升了开发效率，也在悄然改变着程序员的工作方式。</p>
  <p>未来的开发者需要更多地扮演"架构师"和"审阅者"的角色，将精力集中在系统设计和代码质量把控上，而非逐行编写样板代码。</p>

  <h2>总结</h2>
  <p>2026年的前端技术格局正在发生深刻变革：React 19重塑了开发范式，WebAssembly走向成熟应用，AI工具深度融入开发流程。对于前端开发者来说，拥抱变化、持续学习是不变的主题。海角论坛技术交流板块将持续关注这些前沿话题，欢迎各位开发者一起讨论交流！</p>
</article>`,
    categoryId: 'tech-discuss',
    categoryName: '技术交流',
    author: '码农小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20developer%20portrait%20avatar%20in%20casual%20style%20with%20warm%20lighting%20simple%20background%20clean%20minimal%20headshot&width=80&height=80&seq=avatar-tech-01&orientation=squarish',
    publishDate: '2026-08-06',
    readCount: 12580,
    commentCount: 342,
    likes: 892,
    tags: ['前端开发', 'React', 'WebAssembly', '技术趋势'],
    isHot: true,
    isPinned: true,
  },
  {
    id: 2,
    title: '从零开始学摄影：新手必知的构图技巧与器材选择指南',
    excerpt: '摄影是一门光影的艺术，但对于新手来说，如何快速入门？本文从构图法则、光线运用和器材选购三个角度，为零基础爱好者提供一份完整的入门指南。',
    contentHtml: `<article>
  <p>摄影已经成为现代人记录生活的重要方式。无论是手机摄影还是专业相机，掌握基本的构图技巧和器材知识，都能让你的照片质量有一个质的飞跃。</p>

  <h2>三大基础构图法则</h2>
  <p><strong>三分法则</strong>是最基础也是最实用的构图技巧。将画面用两条横线和两条竖线分成九等份，把主体放在交叉点上，可以让画面更加平衡和谐。几乎所有相机和手机都内置了三分线网格功能，建议始终保持开启。</p>
  <p><strong>引导线构图</strong>利用画面中的线条元素——道路、栏杆、河流等——将观众的视线引向主体。这种方法特别适合风光摄影和街拍，能让照片有更强的纵深感和故事性。</p>
  <p><strong>框架构图</strong>则是利用门框、窗户、树枝等自然形成的"框架"来突出主体，增加画面的层次感和趣味性。</p>

  <h2>新手器材选择建议</h2>
  <p>对于刚入门的摄影爱好者，不必盲目追求昂贵的器材。一部当前主流的旗舰手机已经能够满足90%的日常拍摄需求。如果想入手专业相机，建议从入门级微单开始，搭配一支标准变焦镜头，预算控制在5000-8000元即可。</p>
  <p>记住：最好的相机是你手里的那一台。器材只是工具，真正决定照片质量的是镜头后面的那颗脑袋。</p>

  <h2>后期处理的价值</h2>
  <p>适当的后期处理是数码摄影不可或缺的一环。Lightroom和Snapseed是两款非常适合新手的后期工具。调整曝光、对比度和色彩饱和度，往往能让一张平淡的照片焕发新生。但要注意不要过度处理，保持照片的自然感。</p>
</article>`,
    categoryId: 'life-share',
    categoryName: '生活分享',
    author: '光影追梦人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Creative%20photographer%20portrait%20with%20camera%20warm%20natural%20lighting%20simple%20studio%20background%20friendly%20expression&width=80&height=80&seq=avatar-life-01&orientation=squarish',
    publishDate: '2026-08-05',
    readCount: 8920,
    commentCount: 218,
    likes: 654,
    tags: ['摄影入门', '构图技巧', '器材选购'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 3,
    title: '2026年旗舰手机横评：iPhone 17 Pro vs 华为Mate 80 Pro 全方位对比',
    excerpt: '两大旗舰的巅峰对决！我们从性能、影像、续航、系统体验等维度进行深度对比，帮你找到最适合自己的那款手机。',
    contentHtml: `<article>
  <p>每年秋季的手机旗舰大战总是科技圈最受关注的事件。2026年，iPhone 17 Pro和华为Mate 80 Pro无疑是两大阵营的顶级代表。本文将从多个维度进行详细对比。</p>

  <h2>性能表现</h2>
  <p>iPhone 17 Pro搭载A19 Pro芯片，采用台积电3nm+工艺；华为Mate 80 Pro则配备麒麟9100处理器。在日常使用场景下，两款手机的流畅度都已经超越了绝大多数用户的需求。但在游戏和视频渲染等高负载场景下，A19 Pro的能效比略胜一筹。</p>

  <h2>影像系统</h2>
  <p>这是两款手机竞争最激烈的领域。iPhone 17 Pro延续了自然真实的色彩风格，视频拍摄能力依然是行业标杆。华为Mate 80 Pro则在暗光拍摄和变焦能力上表现突出，XMAGE影像系统让照片更有"德味"。对于摄影爱好者来说，这更像是两种风格的取舍，而非简单的优劣之分。</p>

  <h2>续航与充电</h2>
  <p>华为Mate 80 Pro配备了5500mAh大电池和100W有线快充，从0到100%仅需28分钟。iPhone 17 Pro的续航相比前代有明显提升，但充电速度仍然落后于华为。如果你是一个重度用户或经常出差，华为的续航优势会更明显。</p>
</article>`,
    categoryId: 'digital-product',
    categoryName: '数码产品',
    author: '科技老司机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Tech%20reviewer%20portrait%20with%20glasses%20modern%20clean%20style%20warm%20lighting%20simple%20background%20professional&width=80&height=80&seq=avatar-digital-01&orientation=squarish',
    publishDate: '2026-08-04',
    readCount: 18500,
    commentCount: 567,
    likes: 1230,
    tags: ['手机评测', 'iPhone', '华为', '旗舰对比'],
    isHot: true,
    isPinned: true,
  },
  {
    id: 4,
    title: '《黑神话：悟空2》深度评测：国产3A游戏的又一次飞跃',
    excerpt: '时隔两年，《黑神话：悟空2》带着更宏大的世界观和更成熟的战斗系统回归。这款游戏能否超越前作，成为国产游戏的新标杆？',
    contentHtml: `<article>
  <p>2024年，《黑神话：悟空》以一己之力将国产3A游戏推向了世界舞台。两年后，续作《黑神话：悟空2》带着更高的期待降临。经过50小时的深度体验，我可以负责任地说：这不仅是一次成功的续作，更是一次全面的进化。</p>

  <h2>故事与世界观</h2>
  <p>续作的故事发生在西游世界的另一个维度，玩家将探索更多未被讲述的神话篇章。叙事手法更加成熟，支线任务的丰富程度远超一代，每个NPC都有自己独特的故事线。</p>

  <h2>战斗系统的进化</h2>
  <p>战斗系统是二代最大的亮点。保留了七十二变的核心机制，同时新增了法宝组合系统和环境互动战斗。BOSS战的设计更加精妙，不再是单纯的血条消耗，而是需要玩家真正理解每个BOSS的攻击模式和弱点。</p>

  <h2>技术表现</h2>
  <p>基于虚幻引擎5.4开发，《黑神话：悟空2》的画面表现力达到了新的高度。光线追踪、Nanite虚拟几何体技术的应用让场景细节惊人。优化方面也有明显进步，中端显卡也能稳定60帧运行。</p>
</article>`,
    categoryId: 'game-entertainment',
    categoryName: '游戏娱乐',
    author: '游戏达人阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20gamer%20portrait%20with%20headphones%20casual%20style%20warm%20lighting%20simple%20background%20modern&width=80&height=80&seq=avatar-game-01&orientation=squarish',
    publishDate: '2026-08-03',
    readCount: 22100,
    commentCount: 891,
    likes: 2100,
    tags: ['游戏评测', '黑神话悟空', '3A大作', '国产游戏'],
    isHot: true,
    isPinned: true,
  },
  {
    id: 5,
    title: '职场新人必读：如何在前三个月快速融入团队并展现价值',
    excerpt: '初入职场的前三个月是建立印象的关键期。本文从沟通技巧、任务管理和人际关系三个维度，为新人提供实用建议。',
    contentHtml: `<article>
  <p>从校园到职场，是人生中最重要的转折之一。初入职场的头三个月，往往决定了你在团队中的初始定位和后续发展空间。以下是一些经过验证的实用策略。</p>

  <h2>第一周：观察与学习</h2>
  <p>入职第一周的核心任务是观察和学习。了解团队的工作流程、沟通习惯和决策方式。主动向直属上级了解对你的期望，明确试用期的关键考核指标。记住，多听少说，不懂就问，这时的提问不会被认为能力不足。</p>

  <h2>第一个月：建立信任</h2>
  <p>通过高质量完成交给你的每一个任务来建立信任。即使是简单的文档整理或数据录入，也要做到超出预期。同时，开始主动了解其他同事的工作内容，找到可以协作的机会点。</p>

  <h2>前三个月：展现价值</h2>
  <p>在熟悉了基本工作后，开始寻找可以优化和改进的地方。提出建设性意见时要注意方式方法——先肯定现有的做法，再提出具体的改进建议和可量化的预期效果。让团队看到你的思考深度和主动性。</p>
</article>`,
    categoryId: 'career-education',
    categoryName: '职场教育',
    author: 'HR张姐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20in%20business%20attire%20warm%20lighting%20simple%20studio%20background%20confident%20friendly&width=80&height=80&seq=avatar-career-01&orientation=squarish',
    publishDate: '2026-08-02',
    readCount: 7650,
    commentCount: 189,
    likes: 543,
    tags: ['职场新人', '职业规划', '工作技巧'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 6,
    title: '2026年最值得入手的入门级新能源汽车全面横评',
    excerpt: '10-15万价位区间的新能源汽车市场竞争激烈，我们选取了五款最具代表性的车型，从续航、空间、智能化和性价比角度进行全面对比。',
    contentHtml: `<article>
  <p>随着新能源汽车渗透率突破60%，10-15万价位的入门级市场已成为兵家必争之地。2026年这个价位段涌现了大量优秀产品，让消费者有了更多选择。本文选取五款热门车型进行横向对比。</p>

  <h2>续航能力对比</h2>
  <p>在CLTC工况下，五款车型的续航里程集中在450-580公里之间。其中比亚迪海鸥Plus以580公里的续航领先，而五菱星光S则以更亲民的价格提供了500公里的扎实续航。对于日常通勤和周末出游来说，这些续航数据已经足够。</p>

  <h2>智能化配置</h2>
  <p>2026年的入门级车型在智能化方面进步巨大。L2+级辅助驾驶已经成为标配，部分车型甚至搭载了高速NOA功能。车机系统的流畅度和生态丰富度也成为重要的选购考量点。</p>

  <h2>购车建议</h2>
  <p>如果你追求极致性价比和低使用成本，五菱星光S是不错的选择。如果你更看重智能化和品牌体验，比亚迪海鸥Plus和蔚来萤火虫都值得考虑。建议在下单前一定要进行试驾，实际感受车辆的驾驶质感。</p>
</article>`,
    categoryId: 'car-travel',
    categoryName: '汽车出行',
    author: '车评人老李',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Automotive%20journalist%20portrait%20with%20casual%20jacket%20warm%20lighting%20simple%20background%20friendly%20confident&width=80&height=80&seq=avatar-car-01&orientation=squarish',
    publishDate: '2026-08-01',
    readCount: 9820,
    commentCount: 312,
    likes: 780,
    tags: ['新能源汽车', '购车指南', '车型横评'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 7,
    title: '每天跑步30分钟，身体会发生哪些惊人变化？',
    excerpt: '坚持跑步不仅仅是为了减肥。从心血管健康到大脑功能，从情绪管理到睡眠质量，科学解析跑步对身体的全方位益处。',
    contentHtml: `<article>
  <p>跑步是最简单、最经济的运动方式之一。不需要昂贵的器材，不需要特殊的场地，一双跑鞋就能开始。但坚持跑步带来的健康收益，却远比大多数人想象的要丰富。</p>

  <h2>心血管系统的蜕变</h2>
  <p>坚持跑步三个月后，静息心率平均下降8-12次/分钟。这意味着心脏每次跳动能泵出更多的血液，心血管系统的工作效率显著提升。长期坚持跑步的人群，患高血压和冠心病的风险比久坐不动者低45%以上。</p>

  <h2>大脑功能的提升</h2>
  <p>跑步能刺激BDNF（脑源性神经营养因子）的分泌，这种物质被称为"大脑的肥料"。它能促进神经元生长和突触可塑性，从而提升学习能力和记忆力。这解释了为什么很多跑者反映跑后思维更清晰、工作效率更高。</p>

  <h2>情绪与睡眠的改善</h2>
  <p>跑步过程中释放的内啡肽是天然的抗抑郁剂。规律的跑步运动被多项研究证实对轻中度抑郁症有显著的改善效果。同时，白天进行适度的有氧运动能帮助调节昼夜节律，让你晚上更容易入睡，睡眠质量也会明显提升。</p>
</article>`,
    categoryId: 'health-fitness',
    categoryName: '健康养生',
    author: '运动康复师小陈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fitness%20coach%20portrait%20athletic%20style%20warm%20lighting%20simple%20background%20energetic%20friendly&width=80&height=80&seq=avatar-health-01&orientation=squarish',
    publishDate: '2026-07-31',
    readCount: 11300,
    commentCount: 445,
    likes: 1670,
    tags: ['跑步', '健康', '运动科学', '生活习惯'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 8,
    title: '2026年下半年投资策略：在不确定中寻找确定性',
    excerpt: '全球经济形势复杂多变，如何在波动中把握投资机会？本文从宏观经济、行业选择和资产配置三个层面提供参考建议。',
    contentHtml: `<article>
  <p>2026年上半年全球资本市场经历了剧烈波动，AI概念股分化、美联储降息节奏反复、地缘政治风险不减——投资者面临的不确定性前所未有。本文为普通投资者梳理下半年的投资思路。</p>

  <h2>宏观经济判断</h2>
  <p>美联储在2026年下半年预计将进行1-2次降息，全球流动性环境趋于宽松。国内方面，一揽子稳增长政策持续发力，消费复苏的进程虽然缓慢但方向明确。整体来看，下半年的宏观环境对风险资产偏友好。</p>

  <h2>行业选择逻辑</h2>
  <p>AI应用端是确定性最强的方向之一，但需要区分真正有业绩支撑的公司和纯概念炒作。新能源产业链经历了深度调整后，部分龙头公司的估值已经回到合理区间。消费板块中，具有品牌壁垒和定价权的龙头企业值得长期关注。</p>

  <h2>资产配置建议</h2>
  <p>对于普通投资者，建议采用"核心+卫星"策略：核心仓位配置宽基指数基金，卫星仓位根据个人风险偏好配置行业ETF或个股。保持一定的现金比例，以应对市场波动带来的加仓机会。永远不要试图预测市场顶部和底部，定投和长期持有才是最适合普通人的策略。</p>
</article>`,
    categoryId: 'finance-invest',
    categoryName: '财经投资',
    author: '投资笔记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Financial%20analyst%20portrait%20in%20formal%20attire%20warm%20lighting%20simple%20background%20professional%20confident&width=80&height=80&seq=avatar-finance-01&orientation=squarish',
    publishDate: '2026-07-30',
    readCount: 15200,
    commentCount: 536,
    likes: 1350,
    tags: ['投资策略', '宏观经济', '资产配置', 'A股'],
    isHot: true,
    isPinned: true,
  },
  {
    id: 9,
    title: 'TypeScript 6.0 新特性全解析：类型系统迎来重大升级',
    excerpt: 'TypeScript 6.0带来了多项突破性特性，包括类型推断增强、模式匹配类型和更智能的泛型推导，让类型系统更加灵活强大。',
    contentHtml: `<article>
  <p>TypeScript 6.0的发布在开发者社区引起了广泛讨论。这次更新被誉为TypeScript诞生以来最重要的一次类型系统升级。让我们逐一解析其中最值得关注的新特性。</p>

  <h2>模式匹配类型</h2>
  <p>这是TypeScript 6.0最受瞩目的新特性。借鉴了函数式编程语言中的模式匹配概念，现在你可以在类型层面进行模式匹配。这让复杂的类型变换变得更加直观和易于维护。</p>

  <h2>类型推断全面增强</h2>
  <p>TypeScript 6.0的类型推断引擎经过重写，现在能够推断出更加精确的类型。特别是在处理链式调用、高阶函数和复杂泛型时，不再需要手动标注中间类型。这让代码更加简洁，同时保持了类型安全。</p>

  <h2>泛型推导优化</h2>
  <p>新的泛型推导算法更加智能，能够从多个参数中综合推断类型参数。在React开发中，这意味着useState、useReducer等Hook的类型推导更加准确，hooks组合使用时的类型体验大幅改善。</p>
</article>`,
    categoryId: 'tech-discuss',
    categoryName: '技术交流',
    author: '前端架构师老刘',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Senior%20developer%20portrait%20with%20beard%20casual%20style%20warm%20lighting%20simple%20background%20experienced&width=80&height=80&seq=avatar-tech-02&orientation=squarish',
    publishDate: '2026-07-29',
    readCount: 8900,
    commentCount: 276,
    likes: 720,
    tags: ['TypeScript', '前端开发', '编程语言'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 10,
    title: '一个人的川西自驾之旅：路线规划、开销明细与避坑指南',
    excerpt: '从成都出发，历时7天，穿越稻城亚丁、色达、新都桥。分享一份详细的川西自驾攻略，包含路线、住宿、花费和实战经验。',
    contentHtml: `<article>
  <p>川西，是无数自驾爱好者心中的圣地。雪山、草原、湖泊、寺庙——这条路线浓缩了高原最美的风景。2026年夏天，我终于实现了这个酝酿已久的计划。</p>

  <h2>详细路线规划</h2>
  <p>Day 1：成都-康定（320km，约5小时）。Day 2：康定-新都桥-雅江（200km，约4.5小时）。Day 3-4：雅江-稻城亚丁（350km，约7小时），亚丁景区游玩两天。Day 5：稻城-色达（420km，约8小时）。Day 6：色达-马尔康（280km，约6小时）。Day 7：马尔康-成都（330km，约5小时）。</p>

  <h2>开销明细</h2>
  <p>全程总花费约5800元，其中油费过路费约1800元，住宿7晚约1400元，餐饮约1200元，稻城亚丁门票+观光车约350元，其他杂费约1050元。整体花费比预想的要低，淡季出行住宿和油费都有一定优惠。</p>

  <h2>避坑建议</h2>
  <p>第一，务必提前一周服用红景天，高原反应不是开玩笑的。第二，川西加油站间隔远，遇到加油站就把油箱加满。第三，部分路段信号很差，提前下载离线地图。第四，尊重当地文化和宗教信仰，进入寺庙要注意着装礼仪。</p>
</article>`,
    categoryId: 'car-travel',
    categoryName: '汽车出行',
    author: '旅行者阿远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Travel%20blogger%20portrait%20outdoor%20style%20warm%20lighting%20simple%20background%20adventurous%20friendly&width=80&height=80&seq=avatar-travel-01&orientation=squarish',
    publishDate: '2026-07-28',
    readCount: 16700,
    commentCount: 623,
    likes: 1890,
    tags: ['自驾游', '川西', '旅游攻略', '路线规划'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 11,
    title: 'Python自动化办公实战：用20行代码解放你的重复劳动',
    excerpt: '还在手动整理Excel报表？本文教你用Python编写简单的自动化脚本，批量处理文件、自动生成报告，大幅提升工作效率。',
    contentHtml: `<article>
  <p>在日常工作中，我们经常会遇到重复性高、规则明确的办公任务，比如数据录入、报表生成、文件批量重命名等。这些任务完全可以通过Python脚本自动化完成，让你把时间花在更有价值的工作上。</p>

  <h2>Excel自动化处理</h2>
  <p>使用openpyxl和pandas库，可以轻松读取、处理和生成Excel文件。比如从多个部门的周报中提取关键数据，汇总到一个总表中，原本需要2小时的手工操作，脚本只需10秒就能完成。</p>

  <h2>文件批量操作</h2>
  <p>Python的os和shutil模块提供了强大的文件操作能力。批量重命名、按规则分类归档、自动备份——这些操作都可以用几行代码搞定。结合watchdog库还可以实现文件夹的实时监控和自动处理。</p>

  <h2>邮件自动发送</h2>
  <p>配合smtplib模块，可以实现定时发送邮件、批量发送个性化邮件、自动发送报表等功能。设置好模板和收件人列表后，每周一早上9点自动发送上周的数据汇总——全自动，零操作。</p>
</article>`,
    categoryId: 'tech-discuss',
    categoryName: '技术交流',
    author: 'Python爱好者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Python%20developer%20portrait%20casual%20style%20warm%20lighting%20simple%20background%20friendly%20young&width=80&height=80&seq=avatar-tech-03&orientation=squarish',
    publishDate: '2026-07-27',
    readCount: 10200,
    commentCount: 398,
    likes: 1120,
    tags: ['Python', '自动化', '办公效率', '编程实战'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 12,
    title: '2026年家用路由器选购指南：WiFi 7时代来了，值得升级吗？',
    excerpt: 'WiFi 7路由器已经开始普及，但对于普通家庭用户来说，现在升级是否值得？本文从技术、价格和实际体验三个角度帮你决策。',
    contentHtml: `<article>
  <p>WiFi 7标准的正式落地，让路由器市场迎来了新一轮的升级潮。各大品牌纷纷推出搭载WiFi 7技术的旗舰产品，价格从500元到3000元不等。那么普通家庭用户现在升级WiFi 7路由器究竟有没有必要？</p>

  <h2>WiFi 7相比WiFi 6提升了什么</h2>
  <p>WiFi 7（802.11be）相比WiFi 6在三个核心维度有显著提升：理论峰值速率从9.6Gbps提升到46Gbps；延迟从原来的10ms级别降低到1ms级别；同时连接设备数量大幅增加。但对于普通家庭来说，500M或1000M的宽带套餐下，WiFi 6已经足够应对日常使用。</p>

  <h2>什么情况下值得升级</h2>
  <p>如果你有以下需求，升级WiFi 7是值得的：家中有大量智能家居设备（50+）、经常进行局域网内大文件传输、使用VR/AR设备需要极低延迟、或者你是一个追求极致体验的数码发烧友。否则，一台好的WiFi 6路由器仍然是性价比最高的选择。</p>
</article>`,
    categoryId: 'digital-product',
    categoryName: '数码产品',
    author: '数码控阿强',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Tech%20enthusiast%20portrait%20young%20man%20modern%20style%20warm%20lighting%20simple%20background%20energetic&width=80&height=80&seq=avatar-digital-02&orientation=squarish',
    publishDate: '2026-07-26',
    readCount: 7200,
    commentCount: 203,
    likes: 580,
    tags: ['WiFi7', '路由器', '数码产品', '网络设备'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 13,
    title: '面试官视角：那些让我眼前一亮的简历都有这些共同点',
    excerpt: '作为面试过上千人的资深HR，我总结了优秀简历的5个核心要素。这些细节往往决定了你的简历是被放入"面试"还是"淘汰"那一堆。',
    contentHtml: `<article>
  <p>在招聘旺季，HR每天要浏览数百份简历。平均每份简历的初筛时间不超过30秒。如何在这么短的时间内抓住HR的眼球？以下是我从面试官视角总结的几个关键点。</p>

  <h2>数据化你的成就</h2>
  <p>不要只写"负责XX项目"，而要写"主导XX项目，通过优化流程将交付周期从14天缩短至7天，效率提升50%"。具体的数字能让HR直观感受你的能力。每一个工作经历至少要有1-2个量化的成果。</p>

  <h2>针对性调整简历</h2>
  <p>不要用同一份简历投所有岗位。仔细阅读职位描述，将与之匹配的经验和能力放在最显眼的位置。如果你的经历和岗位要求高度契合，一定要让HR在第一眼就能看到。</p>

  <h2>排版简洁但不简陋</h2>
  <p>简历的排版应该简洁清晰，使用统一的字体和适度的留白。避免花哨的模板和过多的颜色。PDF格式是最安全的选择，确保在不同设备上打开时格式不会错乱。</p>
</article>`,
    categoryId: 'career-education',
    categoryName: '职场教育',
    author: 'HR张姐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20in%20business%20attire%20warm%20lighting%20simple%20studio%20background%20confident%20friendly&width=80&height=80&seq=avatar-career-01&orientation=squarish',
    publishDate: '2026-07-25',
    readCount: 13500,
    commentCount: 478,
    likes: 1560,
    tags: ['求职', '简历', '面试技巧', '职场'],
    isHot: true,
    isPinned: false,
  },
  {
    id: 14,
    title: '秋季养生指南：中医教你顺应时节调理身体',
    excerpt: '立秋过后，天气转凉，人体也需要随之调整。本文从饮食、作息和运动三个方面，分享中医秋季养生的智慧。',
    contentHtml: `<article>
  <p>中医讲究"天人相应"，人体的生理活动应当顺应四时变化。秋季是"收"的季节，阳气渐收，阴气渐长，养生重点在于"养收"。以下是几个简单实用的秋季养生方法。</p>

  <h2>饮食调理：少辛多酸</h2>
  <p>秋季干燥，容易伤肺。饮食上应少吃辛辣刺激的食物，多吃一些酸味食物如山楂、葡萄、柚子等，有收敛肺气的作用。同时，多吃梨、百合、银耳等滋阴润燥的食材，可以缓解秋燥带来的口干、皮肤干燥等问题。</p>

  <h2>作息调整：早卧早起</h2>
  <p>《黄帝内经》说"秋三月，早卧早起，与鸡俱兴"。秋季应当比夏季更早入睡，保证充足的睡眠时间。早睡有助于阳气收敛，早起则顺应阳气舒展。建议晚上10点前入睡，早上6-7点起床。</p>

  <h2>运动建议：适度舒缓</h2>
  <p>秋季运动不宜过于剧烈，以免大汗淋漓耗伤阳气。太极拳、八段锦、散步、瑜伽等舒缓运动是秋季的最佳选择。运动时间最好选择在上午9-11点或下午3-5点，避开早晚的凉意。</p>
</article>`,
    categoryId: 'health-fitness',
    categoryName: '健康养生',
    author: '中医养生堂',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20medicine%20practitioner%20portrait%20gentle%20expression%20warm%20lighting%20simple%20background%20wise%20friendly&width=80&height=80&seq=avatar-health-02&orientation=squarish',
    publishDate: '2026-07-24',
    readCount: 9400,
    commentCount: 321,
    likes: 1120,
    tags: ['中医养生', '秋季养生', '饮食健康', '生活指南'],
    isHot: false,
    isPinned: false,
  },
  {
    id: 15,
    title: '《帝国时代5》正式公布：经典RTS的文艺复兴',
    excerpt: '微软在2026年科隆游戏展上正式公布了《帝国时代5》，全新的引擎、文明的深度扩展以及创新的战役模式让老玩家热泪盈眶。',
    contentHtml: `<article>
  <p>在刚刚结束的2026年科隆游戏展上，微软Xbox Game Studios正式公布了《帝国时代5》。消息一出，全球RTS（即时战略游戏）玩家社区瞬间沸腾。对于这个陪伴了几代玩家的经典系列，第五代正统续作承载了太多期待。</p>

  <h2>全新引擎带来视觉革命</h2>
  <p>《帝国时代5》采用了全新的Essence Engine 6.0，支持实时光线追踪和全局光照。从公布的演示画面来看，建筑细节、单位动画和战场特效都达到了系列前所未有的水准。更重要的是，新引擎在大规模战斗场景下的性能优化做得相当出色，千人同屏不再是梦想。</p>

  <h2>文明系统深度扩展</h2>
  <p>首发将包含16个文明，每个文明不再只是简单的属性加成不同，而是拥有独特的科技树和单位体系。中国文明被确认为首发文明之一，将拥有从商朝到清朝的完整演进路线。</p>

  <h2>创新的战役模式</h2>
  <p>新的"历史战役"模式将允许玩家在单人游戏中体验历史上著名战役的关键决策点，每个决策都会导向不同的战局发展。这种"蝴蝶效应"式的叙事方式让战役有了前所未有的重玩价值。</p>
</article>`,
    categoryId: 'game-entertainment',
    categoryName: '游戏娱乐',
    author: '游戏达人阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20gamer%20portrait%20with%20headphones%20casual%20style%20warm%20lighting%20simple%20background%20modern&width=80&height=80&seq=avatar-game-01&orientation=squarish',
    publishDate: '2026-07-23',
    readCount: 25600,
    commentCount: 1023,
    likes: 3200,
    tags: ['帝国时代', 'RTS', '游戏新闻', 'Xbox'],
    isHot: true,
    isPinned: true,
  },
  {
    id: 16,
    title: '基金定投三年实战复盘：从亏损20%到盈利35%，我学到了什么',
    excerpt: '一个普通投资者的定投实录。经历了2024年的低谷和2026年的回暖，分享真实的收益数据和投资心得。',
    contentHtml: `<article>
  <p>2023年7月，我开始了自己的基金定投之旅。当时上证指数在3200点附近，很多人说"现在是入市的好时机"。三年后的今天回看这段经历，感触颇多。以下是我真实的投资记录和感悟。</p>

  <h2>投资组合与策略</h2>
  <p>我选择了3只基金进行定投：沪深300指数基金（40%）、中证500指数基金（30%）和一只主动管理型科技主题基金（30%）。每月15日固定扣款3000元，雷打不动，完全不受市场情绪影响。</p>

  <h2>真实的盈亏曲线</h2>
  <p>2023年下半年市场开始下行，到2024年2月时，账户累计亏损达到20%。那段时间每天看账户都是煎熬。但我坚持了定投纪律，甚至有几个月还在低位加仓。2025年市场开始回暖，2026年上半年迎来一波像样的反弹。截至2026年7月，三年累计投入108000元，账户市值146000元，累计收益率约35%。</p>

  <h2>三点核心感悟</h2>
  <p>第一，定投最难的不是选基金，而是坚持纪律——市场恐慌时继续买入。第二，不要试图精准择时，也没有人能精准择时。第三，投资是一场马拉松，三年只是起步，复利的力量需要更长的时间来体现。</p>
</article>`,
    categoryId: 'finance-invest',
    categoryName: '财经投资',
    author: '投资笔记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Financial%20analyst%20portrait%20in%20formal%20attire%20warm%20lighting%20simple%20background%20professional%20confident&width=80&height=80&seq=avatar-finance-01&orientation=squarish',
    publishDate: '2026-07-22',
    readCount: 18900,
    commentCount: 756,
    likes: 2100,
    tags: ['基金定投', '投资理财', '实战分享', 'A股'],
    isHot: true,
    isPinned: false,
  },
];

export const getArticleById = (id: number) => {
  return articles.find((a) => a.id === id) || null;
};

export const getArticlesByCategory = (categoryId: string) => {
  return articles.filter((a) => a.categoryId === categoryId);
};

export const getHotArticles = (limit: number = 10) => {
  return [...articles].filter((a) => a.isHot).sort((a, b) => b.readCount - a.readCount).slice(0, limit);
};

export const getLatestArticles = (limit: number = 6) => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
};

export const getRelatedArticles = (currentId: number, categoryId: string, limit: number = 4) => {
  return articles.filter((a) => a.id !== currentId && a.categoryId === categoryId).slice(0, limit);
};